import FloatingEdge from './FloatingEdge';

export { FloatingEdge } from './FloatingEdge';
export { FloatingConnectionLine } from './FloatingConnectionLine';

export const edgeTypes = {
  floating: FloatingEdge,
};
